export default __webpack_public_path__ + "static/088-76b32a922ca32b3a2f11b6aa03693388.jpg";